import axios from 'axios'
import Vue from 'vue';

export default (modifiers) => {
  // @TODO make this path dynamic
  const _axios = axios.create({
    baseURL: ''
  });

  let loader = null;

  // Add loading indicator for requests
  _axios.interceptors.request.use(config => {

    if(modifiers !== "silent") loader = Vue.$loading.show({ container: null, canCancel: false });
    return config;
  }, error => {
    if(modifiers !== "silent") loader ? loader.hide() : null;
    
    return Promise.reject(error);
  });

  // Hide loading indicator
  _axios.interceptors.response.use(response => {
    if(modifiers !== "silent") loader ? loader.hide() : null;
    return response;
  }, function (error) {
    if(modifiers !== "silent") loader ? loader.hide() : null;
    return Promise.reject(error);
  });
  return _axios;
}
